import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import CountryMenu from '@cont/Login/CountryMenu';
import Field from '@base/Form/Field';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import {
  FormContainer,
  FieldWrapper,
  StyledTextField,
  StyledNumberField,
  Error,
  FormSectionHeading
} from '@cont/OfflineCentres/PostPaymentLearnerDetails/styles';
import { isRequired, isLengthMatchError, isValidEmail } from './utils';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const PersonalDetails = ({ registrar, country }) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data: formData } = registrar;
  const { fullName, email, phoneNum } = formData;
  return (
    <FormContainer>
      <FormSectionHeading>Personal details</FormSectionHeading>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="fullName"
          rules={[isRequired('Name is required')]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Enter full name"
              value={value}
              onChange={(data) => onChange(data.target.value)}
              error={hasError}
              disabled={isLoggedIn && fullName}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="phoneNum"
          rules={[
            isRequired('Mobile number is required'),
            isLengthMatchError('Please enter a valid mobile number', 10)
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledNumberField
              fullWidth
              startAdornment={
                <InputAdornment>
                  <CountryMenu country={country} disabled />
                </InputAdornment>
              }
              placeholder="Enter your mobile number"
              onChange={(_, data) => onChange(data)}
              value={value}
              inputProps={{
                type: 'tel',
                maxLength: 10,
                required: true
              }}
              type="tel"
              error={hasError}
              disabled={isLoggedIn && phoneNum}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="email"
          rules={[
            isRequired('Email is required'),
            isValidEmail('Please enter a valid email address')
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Enter email address"
              value={value}
              onChange={(data) => onChange(data.target.value)}
              inputProps={{
                type: 'email',
                required: true
              }}
              type="email"
              error={hasError}
              disabled={isLoggedIn && email}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
    </FormContainer>
  );
};

PersonalDetails.propTypes = {
  registrar: PropTypes.objectOf(PropTypes.any).isRequired,
  country: PropTypes.objectOf(PropTypes.any).isRequired
};

export default PersonalDetails;
